<template>
    <alert class="shadow" :title="__('orders.is_being_processed')" type="light-info">
        <template v-slot:icon>
            <integration-icon :integration="order.integration"/>
        </template>
        <template v-slot:default>
            <div>{{ __('orders.details.amazon_processing') }}</div>
            <div v-if="order.logs.length === 0">
                {{ __('orders.details.provide_order') }}
            </div>
        </template>
    </alert>
</template>

<script>
import Alert from '@components/Alert.vue';
import IntegrationIcon from '@components/Integrations/IntegrationIcon.vue';

export default {
    components: {
        IntegrationIcon,
        Alert,
    },

    props: {
        order: Object,
    },
};
</script>
